import { useEffect, useState } from "react"
import { useRecoilValue } from "recoil"
import { chatListSelector } from "src/recoil/atoms/chats"
import { MessageModel } from "src/recoil/atoms/chats/types"
import { localUserStaticPropsAtom } from "src/recoil/atoms/users"
import { NO_ITEM_TO_LOAD } from "../ChatVirtualizedList"

function useAdvancedChatScroller(scrollElementId: string) {
  const allChatMessages: MessageModel[] = useRecoilValue(chatListSelector)
  const initialChatMessagesPage = allChatMessages.slice(
    Math.max(allChatMessages.length - NO_ITEM_TO_LOAD, 0)
  )
  const localUserProps = useRecoilValue(localUserStaticPropsAtom)

  const attachmentMessages = initialChatMessagesPage.filter(chat =>
    Object.prototype.hasOwnProperty.call(chat, "attachmentURL")
  )

  const downloadedMessages = initialChatMessagesPage.filter(
    chat => chat.attachmentLoadComplete
  )
  const downloadedCount = downloadedMessages.length

  const [initialAttachmentMessagesCount, setInitialAttachmentMessagesCount] = useState<
    number | null
  >(null)

  useEffect(() => {
    if (attachmentMessages.length && !initialAttachmentMessagesCount) {
      setInitialAttachmentMessagesCount(attachmentMessages.length)
    }
  }, [attachmentMessages])

  function scrollToBottom() {
    document
      .getElementById(scrollElementId)
      .scrollTo(0, document.getElementById(scrollElementId).scrollHeight)
  }

  useEffect(() => {
    if (initialAttachmentMessagesCount === downloadedCount) {
      scrollToBottom()
    }
  }, [downloadedCount, initialAttachmentMessagesCount])

  useEffect(() => {
    if (!downloadedMessages.length) return
    if (initialAttachmentMessagesCount === downloadedCount) return
    if (!downloadedMessages.at(-1).attachmentLoadComplete) return
    if (localUserProps.id === downloadedMessages.at(-1).author.id) scrollToBottom()
  }, [downloadedCount])
}

export default useAdvancedChatScroller
